// Release notes shown in-app after an update, and mirrored in the announcement
// email so both tell users the same story.
//
// Bump UPDATE_ID when a new update ships — it's the localStorage key, so a new
// value is what makes the notice appear once for each user.
export const UPDATE_ID = 'update-2';
export const UPDATE_NUMBER = 2;
export const UPDATE_TITLE = 'Update 2 is live';

export const UPDATE_SUMMARY = [
  {
    title: 'Expense class comes from Setup',
    body: "The Fixed / Variable / Savings / Debt pill on each envelope is now a label, not a switch. Linking a spending goal, savings plan, or debt plan in Setup is what decides how cuts treat that category — so the badge and the Strategy math can no longer disagree.",
  },
  {
    title: 'A new Trends tab',
    body: "Spend over time by category, rebuilt from the months you already have. Suggestions write to a spending goal in Setup; you still run Save all in Strategy before they reach envelopes.",
  },
  {
    title: 'Move envelopes between groups',
    body: "The ⇄ button on a Budget row moves that envelope to another group. By default the move applies this month forward, so past months — and your trend history — keep the grouping they actually had.",
  },
  {
    title: 'Months roll forward when you open the app',
    body: "A new calendar month now copies last month's envelopes, leftover Grabbed amounts, and account openings automatically. Live accounts keep their closing balance instead of resetting to $0 on the 1st. Leftover envelope money carries into next month, so sinking funds accumulate.",
  },
  {
    title: 'Ledger rows land in the right month',
    body: "A transaction files into the month of its date, not whichever month happens to be on screen. Paying a card can include an interest amount so principal and interest split the way a statement does.",
  },
  {
    title: 'Help has a Blog tab',
    body: "Tips and notes from the household, moderated before anyone else sees them. Owner posts can publish immediately when they're clean; everything else waits for review.",
  },
];
